import { render } from "./ParticipacionFederalComponent.vue?vue&type=template&id=16c8abf8&scoped=true"
import script from "./ParticipacionFederalComponent.vue?vue&type=script&lang=js"
export * from "./ParticipacionFederalComponent.vue?vue&type=script&lang=js"

import "./ParticipacionFederalComponent.vue?vue&type=style&index=0&id=16c8abf8&scoped=true&lang=css"

import exportComponent from "/Users/luismanuel/Documents/www/tuxtlacomovamos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c8abf8"]])

export default __exports__